import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { dutyStatusChangeRefs } from "../subjects/dutyStatusChange/refs";

/**
 * The driver went into the sleeper berth.
 */
export const sleeperBerthV1 = tmsEventKind(
  { category: "dutyStatus", kind: "sleeperBerth", version: 1 },
  {
    refs: dutyStatusChangeRefs,
    facts: {
      /** Whether a second driver was signed in — a flag, never the co-driver's identity. */
      withCoDriver: z.boolean(),
    },
  },
);

export const SleeperBerthV1Schema = sleeperBerthV1.schema;
export const SleeperBerthV1FactsSchema = sleeperBerthV1.facts;

export type SleeperBerthV1 = z.infer<typeof SleeperBerthV1Schema>;
export type SleeperBerthV1Facts = z.infer<typeof SleeperBerthV1FactsSchema>;

/** Every version of `sleeperBerth`, keyed by version. What `catalog.ts` places under `dutyStatus`. */
export const sleeperBerth = { 1: sleeperBerthV1 } as const;
